/**
 * Triggered by the viewport aspect-ratio selector (4:3 / 5:3 / 16:9).
 * Sets the gamewindow's height via padding-bottom (= height/width %),
 * toggles the body classes the Modern layout reads, keeps the legacy
 * hidden checkbox in sync for older code paths, and nudges the splitter.
 */
export async function switchAspectRatio() {
  const background = document.getElementById("client_gamewindow")!;
  const offsetCheck = <HTMLInputElement>(
    document.getElementById("client_hdviewport_offset")
  );
  const sel = <HTMLSelectElement>(
    document.getElementById("client_viewport_aspect")
  );
  const ratio = sel ? sel.value : "4:3";

  // padding-bottom = height / width:  4:3 -> 75%, 5:3 -> 60%, 16:9 -> 56.25%
  const padding =
    ratio === "16:9" ? "56.25%" : ratio === "5:3" ? "60%" : "75%";
  background.style.paddingBottom = padding;

  // Legacy checkbox: "widescreen-ish" (anything but 4:3) for old readers.
  const legacy = <HTMLInputElement>document.getElementById("client_hdviewport");
  if (legacy) legacy.checked = ratio !== "4:3";

  if (offsetCheck) offsetCheck.disabled = ratio === "4:3";

  // Body classes drive the Modern layout's aspect-ratio CSS.
  document.body.classList.toggle("viewport-hd", ratio === "16:9");
  document.body.classList.toggle("viewport-53", ratio === "5:3");

  try {
    localStorage.setItem("viewportAspect", ratio);
  } catch (e) { /* private mode */ }

  // The IC pane height is derived from the viewport ratio (adjustSplitter,
  // which listens for resize). Nudge it so the pane resizes immediately.
  window.dispatchEvent(new Event("resize"));
}
window.switchAspectRatio = switchAspectRatio;

/** Restore the saved viewport aspect ratio on load. */
function initViewportAspect() {
  let ratio = "4:3";
  try {
    ratio = localStorage.getItem("viewportAspect") || "4:3";
  } catch (e) { /* ignore */ }
  const sel = <HTMLSelectElement>(
    document.getElementById("client_viewport_aspect")
  );
  if (sel) {
    sel.value = ratio;
    switchAspectRatio();
  }
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initViewportAspect);
} else {
  initViewportAspect();
}
